import { clientFactory } from 'common/lib/client-factory';
import { createApp } from './app';

clientFactory({ createApp });
